import styled from 'styled-components';

const CalendarHeaderView = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  height: 40px;
  margin-bottom: 8px;
  .month {
    font-weight: bold;
    font-size: 12px;
    letter-spacing: 1px;
  }
  .icon-empty {
    height: 40px;
    width: 40px;
  }
  .icon {
    height: 40px;
    width: 40px;
    position: relative;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      height: 40px;
      width: 40px;
      background-position: center center;
      background-repeat: no-repeat;
    }
    &.left {
      &:before {
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='40px' height='40px' viewBox='0 0 40 40'%3E%3Ctitle%3ERectangle Copy 8%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='DatePicker-/-Calendar'%3E%3Cg id='Group-2'%3E%3Crect id='Rectangle-Copy-8' fill='%23FFFFFF' x='0' y='0' width='40' height='40'%3E%3C/rect%3E%3Cpath d='M22.1593557,25.4528187 L22.6906808,24.9214937 C22.9100635,24.702111 22.9105212,24.3467957 22.6916192,24.1269552 L19.081795,20.5000107 L22.6918481,16.8732951 C22.9105212,16.6534547 22.9102924,16.2981393 22.6909325,16.0787795 L22.1595846,15.5474545 C21.9399959,15.3278429 21.5837422,15.3278429 21.3641306,15.5474545 L16.8090496,20.1022837 C16.5894609,20.3218953 16.5894609,20.6781261 16.8090496,20.8977377 L21.3639017,25.4528187 C21.5835133,25.6724303 21.9397441,25.6724303 22.1593557,25.4528187 Z' id='left' fill='%231F1F1F' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    }
    &.right {
      &:before {
        background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg xmlns='http://www.w3.org/2000/svg' width='40px' height='40px' viewBox='0 0 40 40'%3E%3Ctitle%3EGroup 2%3C/title%3E%3Cdesc%3ECreated with Sketch.%3C/desc%3E%3Cg id='Symbols' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cg id='DatePicker-/-Calendar' transform='translate(-226.000000, 0.000000)'%3E%3Cg id='Group-2' transform='translate(226.000000, 0.000000)'%3E%3Crect id='Rectangle-Copy-8' fill='%23FFFFFF' x='0' y='0' width='40' height='40'%3E%3C/rect%3E%3Cpath d='M18.1358973,25.4526814 L22.6908181,20.8977606 C22.9104755,20.6780804 22.9104755,20.3219411 22.6907952,20.1022837 L18.1358973,15.5473629 C17.9162399,15.3277056 17.5601007,15.3277056 17.3404204,15.5473629 L16.809164,16.0786193 C16.58985,16.2979333 16.589438,16.6533631 16.8082256,16.8731807 L20.4180727,20.5000107 L16.8082256,24.1268637 C16.589438,24.3466812 16.58985,24.702111 16.809164,24.9214251 L17.3404204,25.4526814 C17.5600778,25.6723388 17.9162171,25.6723388 18.1358973,25.4526814 Z' id='right' fill='%231F1F1F' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
      }
    }
  }
`;

export default CalendarHeaderView;








